import { root } from '@estee/elc-universal-utils';

export const getQueryParams = () => {
    return (<Location>root.location).search;
};
